/**
 *
 */

export const isNumeric = (value) => {
    return value !== null && !isNaN(Number(value));
};
